var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 240,
    viewBox: "0 0 180 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.713 65.9587H151C153.897 65.9587 155.037 66.9451 155.037 69.1998C155.037 70.2332 154.895 70.7498 153.09 73.0045L136.131 94.1887H153.945C155.465 94.1887 156.13 95.363 156.13 96.7721C156.13 98.1813 155.465 99.3556 153.945 99.3556H132.901C129.765 99.3556 128.578 98.3692 128.578 95.9266C128.578 94.8933 128.815 94.0947 131.19 91.1355L147.152 71.1256H131.713C130.193 71.1256 129.528 69.9513 129.528 68.5422C129.528 67.133 130.193 65.9587 131.713 65.9587Z",
    fill: "#58C85A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.97 39.2413H176.243C178.087 39.2413 178.813 39.9071 178.813 41.429C178.813 42.1265 178.722 42.4753 177.573 43.9971L166.781 58.2965H178.117C179.085 58.2965 179.508 59.0891 179.508 60.0403C179.508 60.9915 179.085 61.7841 178.117 61.7841H164.726C162.73 61.7841 161.975 61.1183 161.975 59.4696C161.975 58.7721 162.126 58.2331 163.637 56.2356L173.794 42.7289H163.97C163.002 42.7289 162.579 41.9363 162.579 40.9851C162.579 40.0339 163.002 39.2413 163.97 39.2413Z",
    fill: "#58C85A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.311 0H163.662C165.067 0 165.62 0.517863 165.62 1.70155C165.62 2.24407 165.55 2.51533 164.675 3.69902L156.453 14.8207H165.09C165.827 14.8207 166.149 15.4372 166.149 16.177C166.149 16.9168 165.827 17.5333 165.09 17.5333H154.886C153.366 17.5333 152.791 17.0155 152.791 15.7331C152.791 15.1906 152.906 14.7714 154.057 13.2178L161.796 2.71261H154.311C153.574 2.71261 153.251 2.09611 153.251 1.35631C153.251 0.616502 153.574 0 154.311 0Z",
    fill: "#58C85A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9514 141.237C99.7935 141.237 108.583 131.838 108.583 120.243C108.583 119.39 108.535 118.55 108.443 117.724H143.606H146.946V117.889C163.823 119.564 177.003 133.803 177.003 151.121V162.81H146.946V263H30.0571V162.81H0V151.121C0 133.803 13.1806 119.564 30.0571 117.889V117.724H69.4599C69.3676 118.55 69.32 119.39 69.32 120.243C69.32 131.838 78.1093 141.237 88.9514 141.237Z",
    fill: "#1EB65B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0859 175.751C47.5907 177.838 54.1031 181.762 60.1145 180.76C66.1259 179.758 72.0817 174.498 74.3082 171.994",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5125 181.178L47.1729 187.857",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4589 182.013L63.0612 189.307",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7578 177.838L76.0618 183.095",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.043 175.751C130.539 177.838 124.026 181.762 118.015 180.76C112.003 179.758 106.048 174.498 103.821 171.994",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.616 181.178L130.956 187.857",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.67 182.013L115.068 189.307",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.371 177.838L102.067 183.095",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothes);
export default __webpack_public_path__ + "static/media/clothes.9b058f63c02be2ec83cecd54140e4802.svg";
export { ForwardRef as ReactComponent };